import { rest } from 'msw'
import { ForgotPasswordResponse, ResetPasswordResponse } from 'types/passwords'

const postResetPassword = rest.post<ResetPasswordResponse>(
  `${API_URL}/user/forgot/confirm`,
  async (req, res, ctx) => {
    return res(ctx.json(200))
  }
)
const postForgotPassword = rest.post<ForgotPasswordResponse>(
  `${API_URL}/user/forgot/request`,
  async (req, res, ctx) => {
    return res(ctx.json(200))
  }
)

export default [postResetPassword, postForgotPassword]
